import React, { Component } from 'react'

// import EventMap from './Map_open'
import Map from './Map'
import Results from './Results'
import FilterBar from './FilterBar'
import BigButton from './parts/BigButton'
import LoaderSpinner from './parts/LoaderSpinner'

import './styles/app.css'

import ACRL from './styles/assets/ACRL.png'

import { connect } from 'react-redux'
import { isFilterVirtual, setMapViewport, switchResults, handleFilterChange, setActiveEventitem, getEventsDataIfNeeded, setPublicState} from './actionsReducers'

class App extends Component {
  constructor(props) {
    super(props)
    this.handleSetFilters = this.handleSetFilters.bind(this)
    this.handleResultsShow = this.handleResultsShow.bind(this)
    this.getActiveEvent = this.getActiveEvent.bind(this)
    this.getSuggest = this.getSuggest.bind(this)
    this.zoomOuter = this.zoomOuter.bind(this)
    this.handlePublicState = this.handlePublicState.bind(this)
  }

  componentDidMount() {
    // initial API load to fetch first events, params are default from global state
    const { dispatch, filterSport, filterZip, filterDate, filterDateUntil } = this.props
    dispatch(getEventsDataIfNeeded(filterSport, filterZip, filterDate, filterDateUntil, 1000))
  }

  zoomOuter() {
    const { dispatch } = this.props
    dispatch(setMapViewport({ center: [51.49, 10.34], zoom: 6 }))
  }

  getSuggest(location) {
    // fetch'n'dispatch the geosuggest data from the searchbar
    const { dispatch } = this.props
    dispatch(setMapViewport({ center: [location.lat, location.lng], zoom: 9 }))
  }

  handleSetFilters(val, type) {
    // fetch'n'dispatch the data from all filters, type describes which filter
    const { dispatch } = this.props
    dispatch(handleFilterChange(val, type))
  }

  handleResultsShow() {
    // on mobile, handle the show/hide of the results list
    const { dispatch } = this.props
    dispatch(switchResults(this.props.showResults))
  }

  getActiveEvent(index, position) {
    // fetch'n'dispatch the new active event, which is zoomed in and highlighted in results
    let newViewport = {
      center: position,
      zoom: 14
    }
    const { dispatch } = this.props
    // check, if the active event is already active, then deactivates it
    // if(this.props.activeEventItem === index) {
    // dispatch(setActiveEventitem(null))
    // } else {
    dispatch(setActiveEventitem(index, newViewport))
    // }
  }

  handlePublicState(publicState) {
    const { dispatch } = this.props
    dispatch(setPublicState(publicState))
  }

  render() {
    const { dispatch } = this.props
    return (
      <div className="App">
        {this.props.isRequesting ? <LoaderSpinner /> : null}

        {isFilterVirtual() ? <img src={ACRL} alt="ACRL" className="acrl" /> : null}

        <FilterBar
          publicStateEvents={this.props.eventsBySport}
          publicStateFilter={this.props.filterPublicState}
          getFiltersData={this.handleSetFilters}
          datepickerData={this.props.filterDate}
          datepickerDataUntil={this.props.filterDateUntil}
          radiusData={this.props.filterRadius}
          attendeeCountData={this.props.filterAttendees}
          sportsData={this.props.filterSport}
          place={this.props.preselectedPlace.uiName}
          getSuggest={this.getSuggest}
          onPublicState={this.handlePublicState}
        />

        <Map
          events={this.props.filteredEvents}
          activeEventItem={this.props.activeEventItem}
          getActiveEvent={this.getActiveEvent}
          sportsType={this.props.filterSport}
          mapViewport={this.props.mapViewport}
          getMapViewport={this.getMapViewport}
          zoomOut={this.zoomOuter}
          dispatch={dispatch}
        />

        <Results
          events={this.props.filteredEvents}
          activeEventItem={this.props.activeEventItem}
          getActiveEvent={this.getActiveEvent}
          isVisible={this.props.showResults}
          getFiltersData={this.handleSetFilters}
          premiumOn={this.props.filterPremium}
          radiusData={this.props.filterRadius}
        />

        <BigButton toggle={this.props.showResults} showResults={this.handleResultsShow} />
      </div>
    )
  }
}

function mapStateToProps(storeState) {
  const {
    activeEventItem,
    filterDate,
    filterDateUntil,
    filterZip,
    filterRadius,
    filterAttendees,
    filterSport,
    filterPremium,
    filterPublicState,
    showResults,
    mapViewport,
    eventsBySport,
    filteredEvents,
    preselectedPlace,
  } = storeState

  return {
    activeEventItem,
    filterDate,
    filterDateUntil,
    filterZip,
    filterRadius,
    filterAttendees,
    filterSport,
    filterPremium,
    filterPublicState,
    showResults,
    eventsBySport: eventsBySport[filterSport],
    filteredEvents,
    isRequesting: !(!!eventsBySport && !!eventsBySport[filterSport] && !eventsBySport[filterSport].isRequesting),
    mapViewport,
    preselectedPlace,
  }
}

export default connect(mapStateToProps)(App)



// WEBPACK FOOTER //
// ./src/components/App.js